var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.732 27.498 2.86-1.703a3.68 3.68 0 0 1 1.57-.505c.668-.057 1.34 0 1.99.171l3.422.898a.865.865 0 0 1-.25 1.7l-3.423-.121m-3.985 4.532.824-.468a2.308 2.308 0 0 1 1.086-.3l5.035-.116a5.193 5.193 0 0 0 3.026-1.06l4.71-3.587a.998.998 0 0 0 .173-1.42 1.06 1.06 0 0 0-1.189-.33l-5.254 1.913",
    stroke: "#35404A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.508 27.677 2.58-1.088a.112.112 0 0 1 .146.06l3.184 7.548a.112.112 0 0 1-.06.147L16.78 35.43a.112.112 0 0 1-.147-.06l-3.184-7.548a.112.112 0 0 1 .06-.146z",
    stroke: "#31B59F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.025 16.47c.531-.264 1.18-.219 1.642.224.634.609.647 1.618.042 2.186l-1.618 1.493",
    stroke: "#31B59F",
    strokeWidth: 0.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.376 22.207-1.948 1.948-4.388-4.36c-.985-1.04-1.433-2.729-.169-4.079 1.501-1.603 3.572-1.153 4.557.113 1.096-1.322 3.066-1.608 4.331-.394 1.547 1.484 1.07 3.328.31 4.163-.139.152-.807.82-1.487 1.494",
    stroke: "#35404A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.931db6407d655db43978e7ed788bbba5.svg";
export { ForwardRef as ReactComponent };